import { Link, useHistory } from "react-router-dom";
import { CollapsedMenu, Container } from "./styles";
import { useAppStore } from "../../stores/appStore";
import HamburgerMenu from "../HamburgerMenu";
import { Button } from "../Button";
import useMediaQuery from "../../hooks/useMediaQuery";
import { breakpoints } from "./constants";
import usePublicMode from "../../hooks/usePublicMode";
import AssetSvg from "../AssetSvg";
import SudowriteLogo from "../SudowriteLogo";

function PluginPageHeader({ openLogin }) {
  const user = useAppStore((state) => state.user);
  const history = useHistory();
  const { urlPrefixPlugins } = usePublicMode();

  const isMobile = useMediaQuery(breakpoints.tablet);

  return (
    <Container>
      <SudowriteLogo
        isLink
        size="large"
        opacity={0.5}
      />

      <Link
        className="main-plugins-page-link"
        to={urlPrefixPlugins}
      >
        <div className="pluginTitle">
          <AssetSvg
            src="plugin.svg"
            height={26}
            width={26}
          />{" "}
          plugins
        </div>
      </Link>
      <ul>
        {!user &&
          (isMobile ? (
            <HamburgerMenu>
              <CollapsedMenu>
                <Button
                  tertiary
                  onClick={() => history.push(`${process.env.REACT_APP_MARKETING_PAGE_URL}/faq`)}
                >
                  FAQ
                </Button>
                <Button
                  tertiary
                  onClick={() => history.push(`${process.env.REACT_APP_MARKETING_PAGE_URL}/app/plans?ref=plugins`)}
                >
                  Pricing
                </Button>
                <Button
                  tertiary
                  onClick={openLogin}
                >
                  Log in
                </Button>
              </CollapsedMenu>
            </HamburgerMenu>
          ) : (
            <>
              <li>
                <a href={`${process.env.REACT_APP_MARKETING_PAGE_URL}/faq`}>FAQ</a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_MARKETING_PAGE_URL}/app/plans?ref=plugins`}>Pricing</a>
              </li>
              <li className="login">
                <a onClick={openLogin}>Log in</a>
              </li>
            </>
          ))}
      </ul>
    </Container>
  );
}

export default PluginPageHeader;
